import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { RealEstateDeveloper, RealEstateDeveloperTag } from '../../models/real-estate-developer.model';
import { Paginable, PaginableParams } from '../../utils/pagination.utils';
import { RealEstateDevelopersServiceApi } from './real-estate-developers.service.api';
import { RealEstateDevelopersServiceMock } from './real-estate-developers.service.mock';

export interface RealEstateDevelopersPaginableParams extends PaginableParams {
  tags?: RealEstateDeveloperTag[];
}

@Injectable({
  providedIn: 'root',
  useClass: environment.usingMocks ? RealEstateDevelopersServiceMock : RealEstateDevelopersServiceApi,
})
export abstract class RealEstateDevelopersService {
  abstract get(id: number): Promise<RealEstateDeveloper | null>;
  abstract getAll(params: RealEstateDevelopersPaginableParams): Promise<Paginable<RealEstateDeveloper>>;
}
